import { isNull } from "lodash";
import React, { useCallback, useMemo } from "react";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

// Imported assets
import blueIcon from "../../../../assets/images/map/BlueIcon_Small.png";
import greenIcon from "../../../../assets/images/map/GreenIcon_Small.png";
import redIcon from "../../../../assets/images/map/RedIcon_Small.png";
import yellowIcon from "../../../../assets/images/map/YellowIcon_Small.png";

const Marker = ({
  data,
  onMarkerClick,
  position,
  selectedStation,
}) => {
  const [markerRef/*, marker*/] = useAdvancedMarkerRef();
  const handleClick = useCallback(() => {
    onMarkerClick && onMarkerClick(data);
  }, [data, onMarkerClick]);

  const markerOpacity = useMemo(
    () =>
      selectedStation?.id === data.id || isNull(selectedStation) ? 1 : 0.5,
    [data.id, selectedStation]
  );

  // Determines the icon for a marker based on the location's status
  const chooseMarkerIcon = (locationStatus: string, maintenanceStatus: boolean) => {
    // if (locationStatus === "Cyber Attack") {
    //   return yellowIcon;
    // } else if (locationStatus === "Faulted") {
    //   return redIcon;
    // } else if (maintenanceStatus) {
    //   return blueIcon;
    // } else { // default or locationStatus === "Available"
    //   return greenIcon;
    // }
    if (locationStatus === "Cyber Attack") {
      return yellowIcon;
    } else if (maintenanceStatus) {
      return blueIcon;
    } else if (locationStatus === "Faulted") {
      return redIcon;
    } else { // default or locationStatus === "Available"
      return greenIcon;
    }
  };

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      className={"marker feature"}
      onClick={handleClick}
      position={position}
      ref={markerRef}
      title={data.locName}
      zIndex={selectedStation?.id === data.id ? Number.MAX_SAFE_INTEGER : null}
    >
      <img
        alt=""
        height={selectedStation?.id === data.id ? 48 : 24}
        src={chooseMarkerIcon(data.locationStatusType.codeName, data.maintenanceActive)}
        style={{ opacity: markerOpacity }}
        width={selectedStation?.id === data.id ? 48 : 24}
      />
    </AdvancedMarker>
  );
};

export default Marker;
